import { css } from '@huspy/styled-system/css';

export const vaultConfigStyles = {
  gradientText: css({
    background: '-webkit-linear-gradient(#0E4160, #4A7E8F)',
    WebkitTextFillColor: 'transparent',
  }),
};
